export default __webpack_public_path__ + "static/contactsBlock-70e18fddaaf914238beade0f6de28505.png";